import React from "react";
import { styled } from "styled-components";

import { Loading } from "../../elements/loading";
import { Heading } from "../heading";

import { PublicLayout } from "./components/publicLayout";

export const LayoutWrapper = styled.main.attrs({ "data-testid": "main-layout" } as Partial<
  React.HTMLAttributes<HTMLElement>
>)`
  max-width: 72rem;
  padding: 1.5rem 1rem;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  flex: 1;

  ${({ theme }) => theme.breakpoints.up("xl")} {
    padding: 2rem;
  }
`;

export const Layout: React.FC<
  React.PropsWithChildren<{
    publicLayout?: boolean;
    loading?: boolean;
    title: string;
    showBackBtn?: boolean;
    backLink?: string;
    backLinkText?: string;
    meta?: Maybe<React.ReactElement>;
    actions?: Maybe<React.ReactNode>;
  }>
> = ({ children, loading = false, publicLayout, title, showBackBtn, backLink, backLinkText, meta, actions }) => {
  const Wrapper = publicLayout ? PublicLayout : LayoutWrapper;
  return (
    <Wrapper>
      {title && (
        <Heading>
          {showBackBtn && <Heading.BackLink to={backLink} alt={backLinkText} />}
          <Heading.PageTitle>{title}</Heading.PageTitle>
          <Heading.Meta>{meta}</Heading.Meta>
          <Heading.Actions>{actions}</Heading.Actions>
        </Heading>
      )}
      {loading ? <Loading /> : <div data-testid="content">{children}</div>}
    </Wrapper>
  );
};
